import axios from "axios";

export const BASE_URL =
  typeof window !== "undefined" &&
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

function authConfig() {
  const token = localStorage.getItem("token");

  return token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : {};
}

export async function getStreak() {
  const res = await axios.get(
    `${BASE_URL}/api/streak`,
    authConfig()
  );
  return res.data;
}

export async function dailyCheckIn() {
  const res = await axios.post(
    `${BASE_URL}/api/streak/checkin`,
    {},
    authConfig()
  );
  return res.data;
}

export async function applyReferral(referralCode) {
  const res = await axios.post(
    `${BASE_URL}/api/referral/apply`,
    { referralCode },
    authConfig()
  );
  return res.data;
}